export default "__VITE_ASSET__DDP2qduh__"